module.exports = __webpack_public_path__ + "images/icons/icon-invalid-4c55b867.svg";